module.exports = __webpack_public_path__ + "static/media/home.ee3bae65.svg";